import { useEffect, useState } from 'react';
import api from '../lib/api';

// Lightweight cache — shared across component instances so /site-settings is only fetched once per session.
let cached = null;
let inflight = null;
const listeners = new Set();

const notify = (data) => {
  cached = data;
  listeners.forEach((cb) => cb(data));
};

export default function useSiteSettings() {
  const [data, setData] = useState(cached);

  useEffect(() => {
    listeners.add(setData);
    if (cached) {
      setData(cached);
    } else if (!inflight) {
      inflight = api.get('/site-settings').then((r) => {
        inflight = null;
        notify(r.data || {});
      }).catch(() => {
        inflight = null;
        notify({});
      });
    }
    return () => { listeners.delete(setData); };
  }, []);

  return data || {};
}
